<script setup>
import state from "./state";
import PersonDetailCard from "../components/PersonDetailCard.vue";
import {ref} from "vue";
import {useRouter} from "vue-router";
const router = useRouter();

const participants = state.value.participants;
let totalPrice = 0;

participants.map((participant) => {
  const price = state.value.verkoopregels[participant.job];
  totalPrice += price;
  participant.price = price;

  participant.initials = transformInitials(participant.initials);

  return participant;
});

const hasErrors = ref(false);
const isSubmitting = ref(false);
function transformInitials(initialsInput) {
  let initials = initialsInput.replaceAll(' ', '');
  initials = initials.replaceAll('.', '').toUpperCase().split('');

  return initials.join('.')+'.';
}

function finish() {
  isSubmitting.value = true;
  const data = new FormData();
  data.append( 'action', 'send_entry' );
  data.append('content', JSON.stringify(state.value));

  fetch(window.WPURLS.ajaxurl+"?action=send_entry", {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(state.value),
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Er ging iets mis')
    }
    return response.json()
  })
  .then(data => {
    console.log('Success:', data);
    window.location.href = state.value.info.thankyouPage;
  })
  .catch(error => {
    console.error('Error:', error);
    hasErrors.value = true;
    isSubmitting.value = false;
  });
}

const money = new Intl.NumberFormat('nl-NL', {
  style: 'currency',
  currency: 'EUR',
});

const moneyFormat = (number) => {
    console.log({number});
    if(isNaN(number)) {
        return 'Prijs nog onbekend'
    }
    return money.format(number)
}
</script>

<template>
  <div class="formfields">
    <div>
      <div class="form__title">
        <h2>Controleer uw inschrijving</h2>
      </div>

      <div class="formcards">
        <div class="cardsubscribe-students cardsubscribe-students--prices">
          <p class="cardsubscribe__title">{{ state.info.courseTitle }}</p>

          <div class="cardsubscribe__prices">
            <ul>
              <li v-for="participant in participants">{{ participant.firstName }} {{ participant.lastName }}<span> {{ moneyFormat(participant.price) }}</span></li>
            </ul>
          </div>
          <div class="cardsubscribe__subtotal">
            <p><span>Totaal</span> {{ moneyFormat(totalPrice) }}</p>
          </div>
        </div>
      </div>
    </div>


    <div>
      <div class="form__title">
        <h2>Cursisten</h2>
      </div>

      <div class="formcards">
        <PersonDetailCard v-for="participant in participants" :person="participant" />
      </div>

      <router-link :to="{name: 'participants'}" class="link--grey">Cursisten bewerken</router-link>
    </div>

    <div>
      <div class="form__title">
        <h2>Factuuradres</h2>
      </div>

      <div class="formcards">
        <PersonDetailCard :person="state.invoiceContact" />
      </div>
    </div>

    <div class="entry__field entry__field--last">
      <ul class="ul--checkboxes">
        <li>
          <p>Door op inschrijving afronden te klikken bevestigt u akkoord te gaan met de <a :href="state.info.termsLink" target="_blank">algemene voorwaarden</a>.</p>
        </li>
        <li v-if="participants.length === 1 && state.invoicePerson === 'self'">
          <input v-model="state.keepMeUpdated" id="keepMeUpdates" type='checkbox' value='1' required />
          <label for='terms'>Houd mij op de hoogte van het nieuwste aanbod.</label>
        </li>
        <li v-if="participants.length === 1 && state.invoicePerson === 'self'">
          <span class="entry-notice">Wij sturen uitsluitend relevante informatie met betrekking tot ons aanbod en ontwikkelingen in de mondzorg.</span>
        </li>
      </ul>
    </div>
  </div>

  <div class="entry__error">
    <p class="input-error" v-if="hasErrors">
      Er ging iets mis met het inzenden van de gegevens
    </p>
  </div>

  <div class="buttons">
    <button class="button button--green button--form" @click="finish" :disabled="isSubmitting">
      <span class="button__text">
        Inschrijving afronden
        <span class="loader" v-if="isSubmitting"></span>
      </span>
    </button>
  </div>

</template>
